import React from 'react'
import { Route, Routes } from 'react-router-dom'

import Home from './Home'
import Products from './Products'
import Product from './Product'
import Cart from './Cart'

import Header from 'components/frontend/Header'
import Footer from 'components/frontend/Footer'
import Checkout from './Checkout'
import Profile from './Profile'

import Auth from "../auth"
import { useAuthContext } from 'contexts/AuthContext'

export default function Index() {
    const { isAuthenticated } = useAuthContext()
    return (
        <>
            <Header />
            <main>
                <Routes>
                    <Route index element={<Home />} />
                    <Route path='/products' element={<Products />} />
                    <Route path='/product' element={<Product />} />
                    <Route path='/cart' element={<Cart />} />
                    <Route path='/checkout' element={<Checkout />} />
                    <Route path='profile/*' element={!isAuthenticated ? <Auth /> : <Profile />} />
                </Routes>
            </main>
            <Footer />
        </>

    )
}
